var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"dropper mt-4"},[_c('input',{attrs:{"type":"file","multiple":"multiple","accept":"image/*"},on:{"change":function($event){_vm.grabImages($event.target.files)}}}),_vm._v(" "),_c('span',[_vm._v("Drag files here!")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36bd2704","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Helpers/Uploader.vue
// module id = null
// module chunks = 